import { GroupFS, RoundsFS, SubGroupFS } from "./fund-strategy-export-classes";

export const SUGGESTED_ROUNDS_NAMES = ['Seed', 'A round', 'B round', 'C round', 'D round', 'E round', 'F round', 'H round', 'I round',
  'J round' ];

export const FS_SUGGESTED_TOTAL_COMMITMENT = 55000000;
export const FS_SUGGESTED_EXPECTED_EXPENSES = FS_SUGGESTED_TOTAL_COMMITMENT * 0.2;
export const FS_SUGGESTED_CARRY_PCNT = 0.2;

export const SEED_SUCCESS_ROUNDS: RoundsFS[] = [
  {
    name: 'Seed',
    roundOrder: 0,
    companiesNumber: 2,
    esop: 5,
    preMoney: 7500000,
    round: 2500000,
    investment: 1250000,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: null,
  },
  {
    name: 'A round',
    roundOrder: 1,
    companiesNumber: 2,
    esop: 5,
    preMoney: 35000000,
    round: 7500000,
    investment: 1000000,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 50000000,
  },
  {
    name: 'B round',
    roundOrder: 2,
    companiesNumber: 2,
    esop: 5,
    preMoney: 80000000,
    round: 20000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 250000000,
  },
  {
    name: 'C round',
    roundOrder: 3,
    companiesNumber: 2,
    esop: 5,
    preMoney: 250000000,
    round: 50000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 1,
    exitCompPrice: 600000000,
  },
  {
    name: 'D round',
    roundOrder: 4,
    companiesNumber: 1,
    esop: 5,
    preMoney: 650000000,
    round: 75000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 1,
    exitCompPrice: 1250000000,
  },
];

export const SEED_MODERATE_ROUNDS: RoundsFS[] = [
  {
    name: 'Seed',
    roundOrder: 0,
    companiesNumber: 5,
    esop: 5,
    preMoney: 7500000,
    round: 2500000,
    investment: 1250000,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: null,
  },
  {
    name: 'A round',
    roundOrder: 1,
    companiesNumber: 5,
    esop: 5,
    preMoney: 25000000,
    round: 5000000,
    investment: 1000000,
    writeOff: 0,
    exitCompNumber: 2,
    exitCompPrice: 50000000,
  },
  {
    name: 'B round',
    roundOrder: 2,
    companiesNumber: 3,
    esop: 5,
    preMoney: 55000000,
    round: 15000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 2,
    exitCompPrice: 150000000,
  },
  {
    name: 'C round',
    roundOrder: 3,
    companiesNumber: 1,
    esop: 5,
    preMoney: 95000000,
    round: 25000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 1,
    exitCompPrice: 250000000,
  },
  {
    name: 'D round',
    roundOrder: 4,
    companiesNumber: 0,
    esop: 5,
    preMoney: 250000000,
    round: 40000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: null,
  },
];

export const SEED_WRITEOFF_ROUNDS: RoundsFS[] = [
  {
    name: 'Seed',
    roundOrder: 0,
    companiesNumber: 5,
    esop: 5,
    preMoney: 7500000,
    round: 2500000,
    investment: 1250000,
    writeOff: 2,
    exitCompNumber: 0,
    exitCompPrice: null,
  },
  {
    name: 'A round',
    roundOrder: 1,
    companiesNumber: 3,
    esop: 5,
    preMoney: 25000000,
    round: 5000000,
    investment: 1000000,
    writeOff: 3,
    exitCompNumber: 0,
    exitCompPrice: 50000000,
  },
  {
    name: 'B round',
    roundOrder: 2,
    companiesNumber: 0,
    esop: 5,
    preMoney: 55000000,
    round: 15000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 150000000,
  },
  {
    name: 'C round',
    roundOrder: 3,
    companiesNumber: 0,
    esop: 5,
    preMoney: 95000000,
    round: 25000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 250000000,
  },
  {
    name: 'D round',
    roundOrder: 4,
    companiesNumber: 0,
    esop: 5,
    preMoney: 250000000,
    round: 40000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: null,
  },
];

export const A_SUCCESS_ROUNDS: RoundsFS[] = [
  {
    name: 'A round',
    roundOrder: 0,
    companiesNumber: 1,
    esop: 5,
    preMoney: 35000000,
    round: 7500000,
    investment: 2500000,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 50000000,
  },
  {
    name: 'B round',
    roundOrder: 1,
    companiesNumber: 1,
    esop: 5,
    preMoney: 80000000,
    round: 20000000,
    investment: 1500000,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 250000000,
  },
  {
    name: 'C round',
    roundOrder: 2,
    companiesNumber: 1,
    esop: 5,
    preMoney: 250000000,
    round: 50000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 600000000,
  },
  {
    name: 'D round',
    roundOrder: 3,
    companiesNumber: 1,
    esop: 5,
    preMoney: 650000000,
    round: 75000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 1,
    exitCompPrice: 1250000000,
  },
];

export const A_MODERATE_ROUNDS: RoundsFS[] = [
  {
    name: 'A round',
    roundOrder: 0,
    companiesNumber: 3,
    esop: 5,
    preMoney: 25000000,
    round: 5000000,
    investment: 2500000,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 50000000,
  },
  {
    name: 'B round',
    roundOrder: 1,
    companiesNumber: 3,
    esop: 5,
    preMoney: 55000000,
    round: 15000000,
    investment: 1500000,
    writeOff: 0,
    exitCompNumber: 1,
    exitCompPrice: 150000000,
  },
  {
    name: 'C round',
    roundOrder: 2,
    companiesNumber: 2,
    esop: 5,
    preMoney: 95000000,
    round: 25000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 1,
    exitCompPrice: 250000000,
  },
  {
    name: 'D round',
    roundOrder: 3,
    companiesNumber: 1,
    esop: 5,
    preMoney: 250000000,
    round: 40000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 1,
    exitCompPrice: 350000000,
  },
];

export const A_WRITEOFF_ROUNDS: RoundsFS[] = [
  {
    name: 'A round',
    roundOrder: 0,
    companiesNumber: 2,
    esop: 5,
    preMoney: 25000000,
    round: 5000000,
    investment: 2500000,
    writeOff: 1,
    exitCompNumber: 0,
    exitCompPrice: 50000000,
  },
  {
    name: 'B round',
    roundOrder: 1,
    companiesNumber: 1,
    esop: 5,
    preMoney: 55000000,
    round: 15000000,
    investment: 1500000,
    writeOff: 1,
    exitCompNumber: 0,
    exitCompPrice: 150000000,
  },
  {
    name: 'C round',
    roundOrder: 2,
    companiesNumber: 0,
    esop: 5,
    preMoney: 95000000,
    round: 25000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: 250000000,
  },
  {
    name: 'D round',
    roundOrder: 3,
    companiesNumber: 0,
    esop: 5,
    preMoney: 250000000,
    round: 40000000,
    investment: null,
    writeOff: 0,
    exitCompNumber: 0,
    exitCompPrice: null,
  },
];

export const SEED_PORTFOLIO_SUBGROUPS: SubGroupFS[] = [
  {
    name: 'Success',
    subGrOrder: 0,
    roundsData: SEED_SUCCESS_ROUNDS,
  },
  {
    name: 'Moderate',
    subGrOrder: 1,
    roundsData: SEED_MODERATE_ROUNDS,
  },
  {
    name: 'Write-off',
    subGrOrder: 2,
    roundsData: SEED_WRITEOFF_ROUNDS,
  },
];

export const A_PORTFOLIO_SUBGROUPS: SubGroupFS[] = [
  {
    name: 'Success',
    subGrOrder: 0,
    roundsData: A_SUCCESS_ROUNDS,
  },
  {
    name: 'Moderate',
    subGrOrder: 1,
    roundsData: A_MODERATE_ROUNDS,
  },
  {
    name: 'Write-off',
    subGrOrder: 2,
    roundsData: A_WRITEOFF_ROUNDS,
  },
];

export const SUGGESTED_GROUPS: GroupFS[] = [
  {
    name: 'Seed portfolio',
    grOrder: 0,
    subGroups: SEED_PORTFOLIO_SUBGROUPS,
  },
  {
    name: 'A portfolio',
    grOrder: 1,
    subGroups: A_PORTFOLIO_SUBGROUPS,
  },
];

export const SUGGESTED_ROUNDS_DATA: RoundsFS[] = [
  {
    name: 'Pre-seed',
    roundOrder: 0,
    companiesNumber: null,
    esop: 5,
    preMoney: 4000000,
    round: 1000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'Seed',
    roundOrder: 1,
    companiesNumber: null,
    esop: 5,
    preMoney: 8000000,
    round: 2000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'A round',
    roundOrder: 2,
    companiesNumber: null,
    esop: 5,
    preMoney: 16000000,
    round: 4000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'B round',
    roundOrder: 3,
    companiesNumber: null,
    esop: 5,
    preMoney: 45000000,
    round: 5000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'C round',
    roundOrder: 4,
    companiesNumber: null,
    esop: 5,
    preMoney: 75000000,
    round: 15000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
];

export const SUGGESTED_SUB_GROUPS: SubGroupFS[] = [
  {
    name: 'Success',
    subGrOrder: 0,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
  {
    name: 'x1',
    subGrOrder: 1,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
  {
    name: 'Write-off',
    subGrOrder: 2,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
];
